<template>
  <div class="container welcome">

    <div class="card">
      <div class="card-block">

        <div class="ex-page-content text-center">
          <h1>Bienvenido {{ user.displayName }}</h1>
          <span><i class="fa fa-smile-o icon"></i></span>
          <h5 class="text-muted">Seleccioná alguna de las opciones del menú de la izquierda para continuar.</h5>
          <p>Proximamente aquí estarán los resumenes de tus actividades.</p>
          <div class="alert alert-warning">
            <strong>IMPORTANTE:</strong> No olvides <a href="#" @click="logout()">cerrar tu sesión</a> al terminar.
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import Auth from '../auth'

  export default {
    name: 'welcome',
    data () {
      return {
        user: this.$store.state.auth.user,
      }
    },

    methods: {
      logout() {
        Auth.logout()
      }
    }
  }
</script>

<style scoped>
  h1 {
    font-size: 3em;
    line-height: normal;
    text-shadow: none;
  }
  .icon {
    font-size: 47px;
  }
  .card {
    min-height: 80vh;
  }
  .ex-page-content {
    margin-top: 40px;
  }

  .alert-warning {
    width: 500px;
    margin: auto;
    display: block;
  }

  @media only screen and (max-width: 860px) {
    .alert-warning {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/screens/Welcome.vue